import React from 'react';

const DomainContext = React.createContext({
  domains: {},
  updateDomains: () => {},
});

export default DomainContext;
